var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"alt":"Click here to earn Gridcoin","id":"logo","src":require("../assets/GRCLogoOnly_Purple_Transparent.png")},on:{"click":_vm.addGridcoin}})])}
var staticRenderFns = []

export { render, staticRenderFns }